export const CONVERSION_TOOL_COLUMNS_RESET = 'CONVERSION_TOOL_COLUMNS_RESET';

export const CONVERSION_TOOL_MAPPINGS_FETCH_REQUEST = 'CONVERSION_TOOL_MAPPINGS_FETCH_REQUEST';
export const CONVERSION_TOOL_MAPPINGS_FETCH_SUCCESS = 'CONVERSION_TOOL_MAPPINGS_FETCH_SUCCESS';
export const CONVERSION_TOOL_MAPPINGS_FETCH_FAILURE = 'CONVERSION_TOOL_MAPPINGS_FETCH_FAILURE';

export const CONVERSION_TOOL_MAPPINGS_DELETE_REQUEST = 'CONVERSION_TOOL_MAPPINGS_DELETE_REQUEST';
export const CONVERSION_TOOL_MAPPINGS_DELETE_SUCCESS = 'CONVERSION_TOOL_MAPPINGS_DELETE_SUCCESS';
export const CONVERSION_TOOL_MAPPINGS_DELETE_FAILURE = 'CONVERSION_TOOL_MAPPINGS_DELETE_FAILURE';
